import React, { useRef } from 'react';

const GameWrapper = () => {
  const iframeRef = useRef(null);

  const goFullscreen = () => {
    const iframe = iframeRef.current;
    if (iframe) {
      if (iframe.requestFullscreen) iframe.requestFullscreen();
      else if (iframe.webkitRequestFullscreen) iframe.webkitRequestFullscreen();
      else if (iframe.msRequestFullscreen) iframe.msRequestFullscreen();
    }
  };

  return (
    <div className="game-wrapper">
      <button className="game-fullscreen-btn" onClick={goFullscreen}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 3 21 3 21 9"/>
          <polyline points="9 21 3 21 3 15"/>
          <line x1="21" y1="3" x2="14" y2="10"/>
          <line x1="3" y1="21" x2="10" y2="14"/>
        </svg>
        Fullscreen
      </button>
      <iframe
        ref={iframeRef}
        src="/erp-shooter/index.html"
        title="ERP Blaster"
        className="game-iframe"
        allowFullScreen
      />
    </div>
  );
};

export default GameWrapper;
